import React from "react";
import { Row, Col, Button } from "antd";
import { useHistory } from "react-router-dom";
import Layout from "../../../layout/Dashboard";
import "./home.css";

export default function Home() {
  const history = useHistory();

  return (
    <Layout>
      <div style={{ marginTop: 64, textAlign: "center" }} id="dashboard">
        <div className="header">Selamat Datang di Admin Panel</div>
        <div className="subheader">
          Kelola aplikasi Carenting melalui fitur-fitur yang ada, antara lain
        </div>
        <Row align="top" justify="space-around">
          <Col span={6}>
            <img
              className="icon"
              src={process.env.PUBLIC_URL + "/asset/article.png"}
              alt="Article"
            />
            <div className="icon_info">
              Kelola artikel untuk ditampilkan pada menu discover pasien
            </div>
            <Button
              className="button_primary"
              onClick={() => {
                history.push("/dashboard/article");
              }}
            >
              Manage Article
            </Button>
          </Col>
          <Col span={6}>
            <img
              src={process.env.PUBLIC_URL + "/asset/plan.png"}
              alt="Plan"
              className="icon"
            />
            <div className="icon_info">Verifikasi upgrade plan pasien</div>
            <Button
              className="button_primary"
              onClick={() => {
                history.push("/dashboard/plan");
              }}
            >
              Verif Plan
            </Button>
          </Col>
          <Col span={6}>
            <img
              src={process.env.PUBLIC_URL + "/asset/registrasi.png"}
              alt="Psikolog"
              className="icon"
            />
            <div className="icon_info">
              Verifikasi pendaftaran dari psikolog yang ingin bergabung dengan
              Carenting
            </div>
            <Button
              className="button_primary"
              onClick={() => {
                history.push("/dashboard/psikolog");
              }}
            >
              Verif Registration
            </Button>
          </Col>
        </Row>
      </div>
    </Layout>
  );
}
